import React, { useState, useEffect, useRef } from 'react';
import { Box, TextField, Button, Typography, Paper, MenuItem, Select, FormControl, InputLabel, Grid, Checkbox, Table, TableBody, TableCell, TableHead, TableRow, Divider, Grid2 } from '@mui/material';
import { getUnitDetails, updateLevelById, updateAudioFileForQuestion } from '../service/service'; // Assuming you have this service call
import { useParams, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AudioPlayerComponent from '../components/AudioPlayer';


const questionTypes = ["MC", "MCM", "ACIQ", "ACMC", "CT", "ACIQM", "UVI", "LAR", "CTA"]; // Example options for question type

const hintTypes = ["audio", "text"];

// Create a custom alert component
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UnitEditPage = () => {
  const { courseId, unitId } = useParams();
  const navigate = useNavigate();
  const [unitData, setUnitData] = useState(null);
  const [levels, setLevels] = useState([]);
  const [originalLevels, setOriginalLevels] = useState([]);

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');

  const [file, setFile] = useState(null); // State to store the file
  const [uploadStatus, setUploadStatus] = useState("");


  const fileInputRef = useRef(null);
  useEffect(() => {
    const fetchUnitDetails = async () => {
      try {
        const { data } = await getUnitDetails(courseId, unitId);
        setUnitData(data.unit);
        setLevels(data.levels);
        setOriginalLevels(data.levels)
      } catch (error) {
        console.error('Failed to fetch unit details:', error);
      }
    };
    fetchUnitDetails();
  }, [unitId]);


  const handleLevelChange = (index, key, value) => {
    const updatedLevels = levels.map((level, i) => (i === index ? { ...level, [key]: value } : level));
    setLevels(updatedLevels);
  };

  const handleQuestionChange = (levelIndex, questionIndex, key, value) => {
    const updatedLevels = [...levels];
    updatedLevels[levelIndex].questions[questionIndex][key] = value;
    updatedLevels[levelIndex].questions[questionIndex].isModified = true;
    // const updatedLevels = levels.map((level, i) => 
    //   i === levelIndex
    //     ? { ...level, questions: level.questions.map((q, j) => (j === questionIndex ? { ...q, [key]: value } : q)) }
    //     : level
    // );

    setLevels(updatedLevels);
  };

  const handleOptionChange = (levelIndex, questionIndex, optionIndex, key, value) => {
    console.log(">>>> handle Options change", levelIndex, questionIndex, optionIndex, key, value)
    const updatedLevels = [...levels];

    const { questionType, Answer } = updatedLevels[levelIndex].questions[questionIndex];
    const oldOptionValue = updatedLevels[levelIndex].questions[questionIndex].options[optionIndex]
    if (questionType === 'MCM') {
      const answerArray = Answer.split('; ');
      if (answerArray.includes(oldOptionValue)) {
        const newAnswer = answerArray.filter(option => option !== oldOptionValue);
        newAnswer.push(value);
        updatedLevels[levelIndex].questions[questionIndex].Answer = newAnswer.join('; ');
      }
    } else {
      if (oldOptionValue === Answer) {
        updatedLevels[levelIndex].questions[questionIndex].Answer = value;
      }
    }

    updatedLevels[levelIndex].questions[questionIndex].options[optionIndex] = value;
    updatedLevels[levelIndex].questions[questionIndex].isModified = true;
    setLevels(updatedLevels);
  };

  const hanldeAnswerChange = (levelIndex, questionIndex, optionIndex, questionType, Answer) => {
    console.log(">>> Handle Answer Change ", levelIndex, questionIndex, optionIndex, questionType, Answer);
    const updatedLevels = [...levels];

    switch(questionType) {
      case 'MC': {
        updatedLevels[levelIndex].questions[questionIndex].Answer = Answer;
        break;
      }
      case 'ACIQ': {
        updatedLevels[levelIndex].questions[questionIndex].Answer = Answer;
        break;
      }

      case 'ACMC': {
        updatedLevels[levelIndex].questions[questionIndex].Answer = Answer;
        console.log(">>>> Data", updatedLevels[levelIndex].questions[questionIndex])
        break;
      }
      default:
        console.log("Unknown questionType", questionType);
    }
    updatedLevels[levelIndex].questions[questionIndex].isModified = true;
    setLevels(updatedLevels);
  }


  const handleUpdateLevel = async (levelId, levelData, levelIndex) => {
    setLoading(true);
    try {
      const modifiedQuestions = levelData.questions.filter((questionData) => questionData.isModified);
      // levelData.questions = modifiedQuestions;
      const res = await updateLevelById(levelId, levelData);
      console.log("Updated Res --- ---", res);
      if (res.isValid) {
        setMessage(res.message); // Set the success message
        setOpen(true); // Open the toast
      } else {
        setMessage('Error occurred while updating levels and question');
        setSeverity('error'); // Red toast for error
      }
    } catch (error) {
      console.error('Failed to update level:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false); // Close the toast when done
  };

  const isOptionCorrect = (option, answer, type) => {
    let result = false;

    switch(type) {
      case 'MC': {
        console.log(">>> oPtion", option, typeof option)
        result = option?.toLowerCase() === answer.toLowerCase();
        break;
      }

      case 'ACIQ': {
        result = option?.toLowerCase() === answer.toLowerCase();
        break;
      }
      case 'ACIQM': {
        result = answer?.split('; ').includes(option);
        break;
      }

      case 'MCM': {
        result = answer?.split('; ').includes(option);
        break;
      }
      default: 
        console.log("Unknown type", type);
    }

    return result
  };


    // Handle file selection
    const handleFileSelectOfReplaceAudio = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile && selectedFile.type === "audio/mpeg") {
        setFile(selectedFile);
      } else {
        alert("Please upload a valid MP3 file.");
      }
    };
  
    // Handle form submission
    const replaceAudio = async (e, question, type) => {
      e.preventDefault();
  
      console.log(">>> Quesiton", question);

      const fieldToUpdate = type;
      if (!file) {
        alert("Please select a file to upload.");
        return;
      }
  
      // Prepare the form data
      const formData = new FormData();
      formData.append("file", file); // Add the file to the form data
      formData.append("questionId", question._id); // Replace with actual data
      formData.append("courseId", question.parentCourseId); // Replace with actual data
      formData.append("unitId", question.parentUnitId); // Replace with actual data
      formData.append("levelId",  question.parentLevelId); // Replace with actual data
      formData.append("fieldToUpdate", fieldToUpdate); // Replace with actual data


      const res = await updateAudioFileForQuestion(formData);
      console.log("Res of replace audio", res);

      if (res.message) {
        alert("File Uploaded Successfully")
      } else {
        alert("Something went wrong!!")
      }

      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset the file input field
      }

      // try {
      //   // Post the file to your backend
      //   const response = await axios.post("http://localhost:5000/api/upload", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data", // Required for file uploads
      //     },
      //   });
  
      //   setUploadStatus("File uploaded successfully!");
      //   console.log("Response:", response.data);
      // } catch (error) {
      //   setUploadStatus("File upload failed.");
      //   console.error("Error uploading file:", error);
      // }
    };



  if (!unitData) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100%', width: '100%', backgroundColor: 'background.default', p: 4 }}>
      <Paper elevation={0} sx={{ padding: '2rem', width: '100%' }}>
        {/* Unit Information (Read-only) */}
        <Typography variant="h5" gutterBottom>Edit Unit: {unitData.name}</Typography>
        <Typography variant="subtitle1">Order: {unitData.order}</Typography>
        <Typography variant="subtitle1">Bonus: {unitData.isBonus ? 'Yes' : 'No'}</Typography>

        {/* Level Sections */}
        {levels.map((level, levelIndex) => (
          <Paper
            key={level._id}
            sx={{ 
              mt: 3,
              mb: 3,
              padding: '24px',
              border: '1px solid silver',
            }}
          >
            <Grid container sx={{ padding: "24px"}}>
              {/* Editable Level Name */}
              <Grid item xs={12} md={12}>
                  <Typography sx={{mt:2, mb: 2}} variant="h6">Level {level.order}</Typography>

              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  label="Level Name"
                  variant="outlined"
                  fullWidth
                  value={level.name}
                  onChange={(e) => handleLevelChange(levelIndex, 'name', e.target.value)}
                />
              </Grid>

              {/* Questions */}
              {level.questions.map((question, questionIndex) => (
                <>
                  <br />
                  <Typography sx={{mt:2, mb: 2}} variant="h6">Question: {question.order}</Typography>
                  <br />
                  <Grid container spacing={2} key={question._id}>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>Question Type</InputLabel>
                        <Select
                          value={question.questionType}
                          label="Question Type"
                          onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'questionType', e.target.value)}
                        >
                          {questionTypes.map((type) => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={8}>
                      <TextField
                        label="Question"
                        variant="outlined"
                        fullWidth
                        value={question.question}
                        onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'question', e.target.value)}
                      />
                    </Grid>

                    {
                      ['ACIQ', 'CTA', 'CT'].includes(question.questionType) &&
                      <div className='audio-container'>
                        <AudioPlayerComponent audioUrl={question.url} />
                        <form style={{ marginLeft: "20px" }} onSubmit={(e) => replaceAudio(e, question, 'url')}>
                          <label>Replace Audio {" "}</label>
                          <input type="file" accept=".mp3" onChange={(e) => handleFileSelectOfReplaceAudio(e)} ref={fileInputRef}  />
                          <button type="submit" style={{ marginLeft: "10px" }}>
                            Upload
                          </button>
                        </form>
                      </div> 
                    }

                    {/* {console.log("question options ----", question.Answer)} */}

                    {/* Render Options in Table Form */}
                  {!['ACMC', 'UVI', 'CT', 'LAR'].includes(question.questionType) && <Grid item xs={12}>
                      <Table sx={{ background: 'primary.lighterShade'}}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Option</TableCell>
                            <TableCell>Is Correct Answer</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {Array.isArray(question.options) && question.options.map((option, optionIndex) => (
                            <TableRow key={option._id}>
                              <TableCell>
                                <TextField
                                  value={option}
                                  fullWidth
                                  onChange={(e) => handleOptionChange(levelIndex, questionIndex, optionIndex, 'value', e.target.value)}
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={isOptionCorrect(option, question.Answer, question.questionType)}
                                  onChange={(e) => hanldeAnswerChange(levelIndex, questionIndex, optionIndex,  question.questionType, option)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Grid>}


                    {
                      question && ['ACMC'].includes(question.questionType) ? <Grid item>
                             <Table sx={{ background: 'primary.lighterShade'}}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Option</TableCell>
                            <TableCell>Audio Clip</TableCell>
                            <TableCell>Is Correct Answer</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          { Object.entries(question.options||{}).map(([optionName, audioUrl], optionIndex)  => (
                            <TableRow key={optionName}>
                              <TableCell>
                                {optionName}
                              </TableCell>
                              <TableCell>
                                <div className='audio-container'>
                                  <AudioPlayerComponent audioUrl={audioUrl} />
                                  <form style={{ marginLeft: "20px" }} onSubmit={(e) => replaceAudio(e, question, `options.${optionName}`)}>
                                    <label>Replace Audio {" "}</label>
                                    <input type="file" accept=".mp3" onChange={(e) => handleFileSelectOfReplaceAudio(e)} ref={fileInputRef}  />
                                    <button type="submit" style={{ marginLeft: "10px" }}>
                                      Upload
                                    </button>
                                  </form>
                                </div> 
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  checked={ question.Answer === optionName }
                                  onChange={(e) => { hanldeAnswerChange(levelIndex, questionIndex, optionIndex,  question.questionType, optionName) }}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      </Grid> : null
                    }
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Note Brief"
                        variant="outlined"
                        fullWidth
                        value={question.noteBrief}
                        onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'noteBrief', e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Note Full"
                        variant="outlined"
                        fullWidth
                        value={question.noteFull}
                        onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'noteFull', e.target.value)}
                      />
                    </Grid>


                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel>Hint Type</InputLabel>
                        <Select
                          value={question.hintType}
                          label="Hint Type"
                          onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'hintType', e.target.value)}
                        >
                          {hintTypes.map((type) => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>


                    {(question.questionType === "UVI" || question.questionType === "LAR" )&& 
                    <Grid item xs={12} md={4}>
                      <TextField
                        label="Phrase"
                        variant="outlined"
                        fullWidth
                        value={question.phrase}
                        onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'phrase', e.target.value)}
                      />
                    </Grid>
                    }


                   {question.hintType === "text" && <Grid item xs={12} md={8}>
                      <TextField
                        label="Hint"
                        variant="outlined"
                        fullWidth
                        value={question.hint}
                        onChange={(e) => handleQuestionChange(levelIndex, questionIndex, 'hint', e.target.value)}
                      />
                    </Grid>}

                    {question.hintType === "audio" ? <div>
                      <Grid item xs={12} md={8}>
                        <InputLabel sx={{marginLeft: 2, marginTop: 1}}>Hint Audio</InputLabel>
                      </Grid>
                      <div className='audio-container'>
                        <AudioPlayerComponent audioUrl={question.hintUrl} />
                        <form style={{ marginLeft: "20px" }} onSubmit={(e) => replaceAudio(e, question, `hintUrl`)}>
                          <label>Replace Audio {" "}</label>
                          <input type="file" accept=".mp3" onChange={(e) => handleFileSelectOfReplaceAudio(e)} ref={fileInputRef}  />
                          <button type="submit" style={{ marginLeft: "10px" }}>
                            Upload
                          </button>
                        </form>
                      </div> 
                    </div> : ""}


                    <Grid item xs={12} md={12}>
                      <Divider 
                        sx={{
                          borderBottomWidth: 3,  // Set the thickness
                          borderColor: 'primary.main',
                          mt: 4,
                          mb: 4   // Set the color to blue
                        }}
                      />                  
                    </Grid>
                  
                  
                  </Grid>
                  
                  <br />
                </>
              ))}
            </Grid>

            {/* Save Button for Each Level */}
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              onClick={() => handleUpdateLevel(level._id, levels[levelIndex], levelIndex)}
              disabled={loading}
            >
              {loading ? 'Saving...' : `Save Level ${level.order}`}
            </Button>
          </Paper>
        ))}
      </Paper>

      <Snackbar
        open={open}
        autoHideDuration={4000} // Toast will auto close after 4 seconds
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position of the toast
      >
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UnitEditPage;
